<template>
  <div>
    <div class="search_">
      <div class="back" @click.stop="goBack">
        <van-icon name="arrow-left" />
      </div>

      <van-search
        class="vanSearch"
        v-model="value"
        show-action
        placeholder="请输入食物名称"
        shape="round"
        @search="onSearch"
        @input="searchInput"
        @clear="searchClear"
      >
        <template v-slot:left-icon>
          <img class="search-img" src="@/assets/images/icon/search.png" />
        </template>
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
    </div>
    <div class="history_">
      <div class="his" v-if="searchList && searchList.length != 0">
        <div class="his-title">
          <p class="his_icon">搜索历史</p>
          <div class="del" @click="delHander">
            <img src="@/assets/images/icon/delete.png" />
          </div>
        </div>
        <div class="list">
          <div class="history-list">
            <div
              class="list-item"
              v-for="(item, index) in searchList"
              :key="index"
              @click="goDetail(item, true, false)"
            >
              {{ item | sliceText(8) }}
            </div>
          </div>
        </div>
      </div>
      <div class="hot" v-if="hotList && hotList.length != 0">
        <div class="hot-title">
          <p class="hot_icon">热门搜索</p>
        </div>
        <div class="list">
          <div class="history-list">
            <div
              class="list-item"
              v-for="(item, index) in hotList"
              :key="index"
              @click="goDetail(item[0], false, true)"
            >
              {{ item[0] | sliceText(8) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { uniqueArr } from '@/assets/js/common.js';
import API from '@/utils/axiosApi/canEatApi';

export default {
  name: 'SearchHistory',
  data() {
    return {
      title: this.$route.query.title || '能不能吃', //页面标题
      value: '', //搜索词
      history: false, //历史记录
      searchList: [], //搜索记录
      hotList: [] // 热词记录
    };
  },

  mounted() {
    document.title = this.title;
    this.initHistory(); //历史记录
    this.hotSearchList(); //热词记录
    this.onFocus();
  },
  methods: {
    uniqueArr,
    onFocus() {
      this.$nextTick(() => {
        try {
          const input = document.getElementsByClassName(
            'van-field__control'
          )[0];
          input.focus();
        } catch (e) {}
      });
    },

    //点击搜索
    onSearch(value) {
      if (this.value.replace(/\s*/g, '') == '') {
        this.$toast('请输入食物名称');
      } else {
        this.goDetail(this.value, false, false);
      }
    },
    //搜索值发生改变 限制最大程度
    searchInput() {
      if (this.value.length >= 50) {
        this.value = this.value.slice(0, 50);
      }
    },

    // 输入框清除按钮
    searchClear() {
      this.value = '';
    },

    // 清除历史记录
    delHander() {
      this.$dialog
        .confirm({
          message: '是否清空全部搜索记录？',
          confirmButtonText: '确定删除',
          confirmButtonColor: '#D4A437',
          cancelButtonColor: '#333'
        })
        .then(() => {
          localStorage.setItem('eatSearchList', '');
          this.searchList = [];
        })
        .catch(() => {});
    },
    // 点击跳转详情
    goDetail(text, isHistory, isHot) {
      sensors.track('Eatable_SentSearch', {
        page_name: this.title,
        key_word: text,
        is_history: isHistory,
        is_Hot_search: isHot,
        module_name:'能不能吃',
        per_page_name:'能不能吃',
        per_module_name:'能不能吃'
      });

      //往storage添加历史记录
      this.searchList.unshift(text);
      this.searchList = this.uniqueArr(this.searchList);
      if (this.searchList.length > 10) {
        this.searchList = this.searchList.slice(0, 10);
      }
      localStorage.setItem('eatSearchList', this.searchList.join(','));

      this.$router.push({
        path: '/canEatListSearchDetail',
        query: {
          searchText: text,
          title: this.title,
          isHot: isHot,
          isHis: isHistory
        }
      });
    },
    // 获取本地搜索记录，初始化本地搜索记录
    initHistory() {
      var historyStr = '';
      if (
        localStorage.getItem('eatSearchList') &&
        localStorage.getItem('eatSearchList') !== ''
      ) {
        historyStr = historyStr + ',' + localStorage.getItem('eatSearchList');
        localStorage.removeItem('eatSearchList');
      }
      localStorage.setItem('eatSearchList', historyStr);
      historyStr.split(',').forEach((item) => {
        if (item == '') return;
        this.searchList.push(item);
      });
    },
    // 搜索热词
    hotSearchList() {
      API.getFoodSearchHot({}, (res) => {
        if (res.code == '200') {
          this.hotList = res.data.slice(0, 10);
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    }
  },
  filters: {
    // 文字超过8位显示省略号
    sliceText: function(text, index) {
      if (text.length > index) {
        return text.slice(0, index) + '...';
      } else {
        return text.slice(0, index);
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .van-field__value {
  padding-left: 14px;
}
/deep/ .van-field__control {
  line-height: 23px;
}
.search-img {
  width: 14px;
  position: absolute;
  top: 50%;
  margin-top: -9px;
}
.search_ {
  width: 100%;
  background: @expertFontColor255;
  overflow: hidden;
  padding-bottom: 12px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 98;
  .back {
    float: left;
    font-size: @indexFontSize20;
    padding-top: 19px;
    width: 22px;
    text-align: right;
    padding-left: 5px;
  }

  .van-search {
    width: 91%;
    padding: 12px 0 0 12px;
    font-size: @indexFontSize12;
    float: left;
    .van-search__action {
      padding: 0 12px;
      font-size: @indexFontSize14;
    }
  }
  .vanSearch1 {
    width: 90%;
    padding: 12px 0 0 12px;
  }
  @media screen and (max-width: 640px) {
    .vanSearch1 {
      width: 316px;
    }
  }
  span.canBtn {
    height: 58px;
    width: 47px;
    line-height: 58px;
    display: inline-block;
    float: left;
    font-size: @indexFontSize14;
    color: @expertFontColor51;
    // padding: 22px 0 0;
    text-align: center;
  }
}
.history_ {
  position: fixed;
  bottom: 0;
  top: 48px;
  left: 0;
  right: 0;
  background: @expertFontColor255;
  padding-left: 12px;
  padding-top: 25px;
  z-index: 110;
  .his-title,
  .hot-title {
    padding-right: 12px;
    display: flex;
    justify-content: space-between;
    p {
      font-size: 16px;
      font-weight: 500;
      color: @expertFontColor51;
      line-height: 1;
    }
    .del {
      width: 13px;
      height: 13px;
      img {
        width: 100%;
      }
    }
    .his_icon,
    .hot_icon {
      padding-left: 18px;
      background-position: left top;
      background-repeat: no-repeat;
      font-weight: bold;
    }
    .his_icon {
      background-image: url('~@/assets/images/icon/his.png');
      background-size: 13px 13px;
    }
    .hot_icon {
      background-image: url('~@/assets/images/icon/hot1.png');
      background-size: 11px 14px;
    }
  }
  .list {
    .history-list {
      margin-top: 12px;
      font-size: 14px;
      font-weight: 400;
      color: @expertFontColor51;
      display: flex;
      flex-wrap: wrap;
      line-height: 1;
      .list-item {
        padding: 9px 12px 8px;
        text-align: center;
        background: @expertBorderColor242;
        border-radius: 15px;
        margin-right: 12px;
        margin-bottom: 12px;
      }
    }
  }
  .his {
    margin-bottom: 20px;
  }
  .hot {
    padding-bottom: 20px;
  }
}
</style>
